import React from 'react';
import withResponsiveCheck from '../ResponsiveCheckHOC';
import ImageBenefit1 from './assets/Image-Benefit1.png';
import ImageBenefit2 from './assets/Image-Benefit2.png';
import ImageBenefit3 from './assets/Image-Benefit3.png';
import './HeroCard.scss';

const HeroCard = props => {
  const cvBenefits = [
    {
      benefitName: 'play-for-free',
      imageSrc: ImageBenefit1,
      title: 'PLAY FOR FREE',
      subTitle: `Play our most popular games online anytime`
    },
    {
      benefitName: 'earn-real-rewards',
      imageSrc: ImageBenefit2,
      title: 'EARN REAL REWARDS',
      subTitle: `Redeem at any Wind Creek location for FREE Play, FREE food, Spa Services and more.`
    },
    {
      benefitName: 'find-your-winning-moment',
      imageSrc: ImageBenefit3,
      title: 'FIND YOUR WINNING MOMENT',
      subTitle: `Join in online tournaments, drawings and auctions for MORE chances to win`
    }
  ];

  return (
    <div className="cv-landing-hero-card-wrapper">
      {props.isMobileView ? (
        <>
          <div className="cv-landing-hero-card mobile-view"></div>
          <div className="cv-landing-hero-card-benefit-section mobile-view">
            {cvBenefits &&
              cvBenefits.map((item, index) => {
                return (
                  <div
                    className="cv-landing-benefit-lists"
                    key={`${item.benefitName}-${index}`}
                  >
                    <div className="cv-landing-benefit-list">
                      <img src={item.imageSrc} alt="" />
                    </div>
                    <div className="cv-landing-benefit-list">
                      <h2>{item.title}</h2>
                      <h6>{item.subTitle}</h6>
                    </div>
                  </div>
                );
              })}
          </div>
        </>
      ) : (
        <div className="cv-landing-hero-card">
          <div className="cv-landing-hero-card-benefit-section">
            {cvBenefits &&
              cvBenefits.map((item, index) => {
                return (
                  <div
                    className="cv-landing-benefit-lists"
                    key={`${item.benefitName}-${index}`}
                  >
                    <div className="cv-landing-benefit-list">
                      <img src={item.imageSrc} alt="" />
                    </div>
                    <div className="cv-landing-benefit-list">
                      <h2>{item.title}</h2>
                      <h6>{item.subTitle}</h6>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default withResponsiveCheck(HeroCard);
